import React, { useEffect, useRef, useState } from "react";
import Marquee from "react-fast-marquee";
import SupportersList from "./supporters-list";
import DashedLine from "../dashed-line";
import useSupporters from "./use-supporters";
import { AnimatePresence, motion } from "framer-motion";
import { useWindowScroll, useWindowSize } from "react-use";

const BASE_SPEED = 50;
const HOVER_SPEED = 20;

const SupportersMarquee = () => {
  const { isActive } = useSupporters();
  const marqueeContainerRef = useRef(null);

  if (!isActive) return;

  // Changing react-fast-marquee's `speed` prop rewrites its CSS
  // `--duration` custom property, which resets the running animation's
  // progress in the browser. Keep `speed` constant and instead scale the
  // existing animation via the Web Animations API so playback continues
  // seamlessly from wherever it currently is.
  const setPlaybackRate = (rate) => {
    marqueeContainerRef.current
      ?.querySelectorAll(".rfm-marquee")
      .forEach((el) => {
        el.getAnimations().forEach((anim) => {
          anim.playbackRate = rate;
        });
      });
  };

  return (
    <motion.div
      key="supporters-marquee-wrapper"
      initial={{ height: 0 }}
      animate={{ height: "auto" }}
      exit={{ height: 0 }}
      onMouseEnter={() => setPlaybackRate(HOVER_SPEED / BASE_SPEED)}
      onMouseLeave={() => setPlaybackRate(1)}
    >
      <AnimatePresence>
        <motion.div
          className="supporters-marquee"
          key="supporters-marquee"
          initial={{ height: 0 }}
          animate={{ height: "auto" }}
          exit={{ height: 0 }}
          ref={marqueeContainerRef}
        >
          <DashedLine />
          <Marquee autoFill={true} speed={BASE_SPEED}>
            <SupportersList />
          </Marquee>
        </motion.div>
      </AnimatePresence>
    </motion.div>
  );
};

export default SupportersMarquee;
